
import {zip as observableZip,  Subscription, Observable } from 'rxjs';
import { Component, OnInit, ViewChild, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { SubscriptionService } from '../../services/subscription.service';
import { AccountTypeOverview, GetSubscriptionInfoDto } from '../../models/subscriptions/subscription.models';
import { SelectableItem } from '../../models/common/selectableItem';
import { PaymentMethod, SubscriptionServiceType } from '../../models/subscriptions/subscription.enums';
import { LoggedInUserService } from '../../auth/logged.in.user';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { PaymentService } from '../../services/payment.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Configuration } from '../../configuration';
import { CmsDialogService } from '../../services/cms.dialog.service';
import { CmsDialogDto } from '../../models/cms.dialogs/cms.dialogs.models';

declare var dataLayer: any[];

@Component({
    selector: 'phone',
    template: require('./phone.component.html'),
    encapsulation: ViewEncapsulation.None
})
export class PhoneComponent {
    

    constructor(private subscriptionService: SubscriptionService,
        private loggedInUserService: LoggedInUserService,
        private readonly cmsDialogService: CmsDialogService,
        private router: Router,
        private authService: AuthService,
        private paymentService: PaymentService,
        private route: ActivatedRoute,
        private config: Configuration) {
        
    }

    ngOnInit() {

        if (this.config.environmentInfo.environmentName == "Live") {
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: 'ty_phone'
                });
            }
        }
    }

    
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/subscription/phone.component.ts